import { render, staticRenderFns } from "./devData.vue?vue&type=template&id=5698a30d&scoped=true&"
import script from "./devData.vue?vue&type=script&lang=js&"
export * from "./devData.vue?vue&type=script&lang=js&"
import style0 from "./devData.vue?vue&type=style&index=0&id=5698a30d&scoped=true&lang=scss&"
import style1 from "./devData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5698a30d",
  null
  
)

export default component.exports